// extracted by mini-css-extract-plugin
export default {"segmentTabContainer":"styles_segmentTabContainer__SJD3+","disabled":"styles_disabled__rg-ZF","custom_brand53":"styles_custom_brand53__BiTvU"};